import AlertDialog from "../components/AlertDialog";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Typography, TextField, Button, Grid, Card } from "@mui/material";
import { api } from "common";
import { useTranslation } from "react-i18next";
import { useNavigate ,useLocation} from "react-router-dom";
import CircularLoading from "components/CircularLoading";
import { makeStyles } from "@mui/styles";
import { colors } from "../components/Theme/WebTheme";

const useStyles = makeStyles((theme) => ({
  textField: {
    "& label.Mui-focused": {
      color: colors.MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: colors.MAIN_COLOR,
      },
    },
  },
  rootRtl: {
    "& label": {
      right: 10,
      left: "auto",
      paddingRight: 20
    },
    "& legend": {
      textAlign: "right",
      marginRight: 20
    },
    "& label.Mui-focused": {
      color: colors.MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: colors.MAIN_COLOR,
      },
    },
  },
  rootRtl_3: {
    "& label": {
      right: 0,
      left: "auto",
      paddingRight: 20
    },
    "& legend": {
      textAlign: "right",
      marginRight: 20
    },
    "& label.Mui-focused": {
      color: colors.MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: colors.MAIN_COLOR,
      },
    },
  },
  rootRtl_2: {
    "& label": {
      right: 5,
      left: "auto",
      paddingRight: 20
    },
    "& legend": {
      textAlign: "right",
      marginRight: 20
    },
    "& label.Mui-focused": {
      color: colors.MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: colors.MAIN_COLOR,
      },
    },
  },
  rootRtl_1: {
    "& label": {
      right: 10,
      left: "auto",
      paddingRight: 20
    },
    "& legend": {
      textAlign: "right",
      marginRight: 15
    },
    "& label.Mui-focused": {
      color: colors.MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: colors.MAIN_COLOR,
      },
    },
  },

  selectField_rtl: {
    color: "black",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.MAIN_COLOR,
    },
    "& label": {
      right: 0,
      left: "auto",

    },
    "& legend": {
      textAlign: "right",
      marginRight: 35,
    },
  },

  right: {
    textAlign: "right", right: 0, left: "auto", paddingRight: 40
  },
  right_1: {
    textAlign: "right", right: 0, left: "auto", paddingRight: 45
  },


  selectField: {
    color: "black",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.MAIN_COLOR,
    },
  },
}));

const AddDriver = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { addUser, checkUserExists, fetchUsersOnce } = api;
  const [approved, setApproved] = useState("");
  const [active, setActive] = useState("");
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [fleetAdmins, setFleetAdmins] = useState([]);
  const [fleetAdminsObj, setFleetAdminsObj] = useState("");
  const [role, setRole] = useState(null);
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const [loding, setLoding] = useState(false);
  const [countries, setCountries] = useState();
  const countrylistdata = useSelector((state) => state.countrylistdata);
  const classes = useStyles();
  const [fleet, setFleet] = useState();
  const [data, setData] = useState({
    email: "",
    mobile: "",
    verifyId: "",
    firstName: "",
    lastName: "",
    approved: "",
    country:"",
    walletBalance: 0,
    queue: false
  });
  const {state} = useLocation();


  useEffect(() => {
    dispatch(fetchUsersOnce());
  }, [dispatch, fetchUsersOnce]);

  useEffect(() => {
    if (staticusers) {
      if (role === "admin" || role === 'subadmin' ) {
        let arr = staticusers.filter((user) => user.usertype === "fleetadmin");
        let obj = {};
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          let user = arr[i];
          arr2.push({
            id: user.id,
            desc:
              user.firstName +
              " " +
              user.lastName +
              " (" +
              (settings.AllowCriticalEditsAdmin
                ? user.mobile
                : t("hidden_demo")) +
              ") " +
              (settings.AllowCriticalEditsAdmin
                ? user.email
                : t("hidden_demo")),
          });
          obj[user.id] =
            user.firstName +
            " " +
            user.lastName +
            " (" +
            (settings.AllowCriticalEditsAdmin
              ? user.mobile
              : t("hidden_demo")) +
            ") " +
            (settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo"));
        }
        setFleetAdmins(arr2);
        setFleetAdminsObj(obj);
      }
    }
  }, [
    staticusers,
    auth.profile.usertype,
    auth.profile.uid,
    settings.AllowCriticalEditsAdmin,
    role, t
  ]);

  useEffect(() => {
    if (countrylistdata && countrylistdata.countries && countrylistdata.countries.length > 0) {
      const countries = [...countrylistdata.countries].sort((a, b) => a.pos - b.pos);
      let arr = [];
      for (let i = 0; i < countries.length; i++) {
        arr.push({
          label: countries[i].country,
          code: countries[i].country_code,
          phone: countries[i].phone_code,
        });
      }
      setCountries(arr);
    }
  }, [countrylistdata, countrylistdata.countries]);

  const handleCountryChange = (event) => {
    setData({ ...data, country: event.target.value });
  };

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  const getKeyByValue = (object, value) => {
    return Object.keys(object).find((key) => object[key] === value);
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const handleChangeApproved = (event) => {
    setApproved(event.target.value);
    setData({ ...data, approved: event.target.value });
  };

  const handleChangeActive = (event) => {
    setActive(event.target.value);
    setData({ ...data, driverActiveStatus: event.target.value });
  };

  const handleChangeFleetAdmin = (event) => {
    const selectedFleetAdmin = event.target.value;
    setData({
      ...data,
      fleetadmin: getKeyByValue(fleetAdminsObj, selectedFleetAdmin),
    });
    setFleet(selectedFleetAdmin);
  };

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.id]: e.target.value });
  };

  const handelSubmit = () => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!data.lastName || !data.firstName) {
      setCommonAlert({ open: true, msg: t("proper_input_name") });
    } else if (!re.test(data.email)) {
      setCommonAlert({ open: true, msg: t("proper_email") });
    } else if (!data.verifyId) {
      setCommonAlert({ open: true, msg: t("verifyid_error") });
    } else if (!data.mobile) {
      setCommonAlert({ open: true, msg: t("proper_mobile") });
    } else if (data.approved === "") {
      setCommonAlert({ open: true, msg: t("check_approve_status") });
    } else if (data.country === "") {
      setCommonAlert({ open: true, msg: t("country_blank_error") });
    } else {
      setLoding(true);
      checkUserExists(data)
        .then((res) => {
          if (res.users && res.users.length > 0) {
            setCommonAlert({ open: true, msg: t("user_exists") });
            return Promise.reject(new Error(JSON.stringify({ errorType: "user_exists" })));
          } else if (!(data && data.firstName)) {
            setCommonAlert({ open: true, msg: t("proper_input_name") });
            return Promise.reject(new Error(JSON.stringify({ errorType: "proper_input_name" })));
          } else if (res.error) {
            setCommonAlert({ open: true, msg: t("email_or_mobile_issue") });
            return Promise.reject(new Error(JSON.stringify({ errorType: "email_or_mobile_issue" })));
          }
            data["usertype"] = "driver";
            data["createdAt"] = new Date().getTime();
            const c = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const reference = [...Array(5)].map((_) => c[~~(Math.random() * c.length)]).join("");
            data["referralId"] = reference;
            const role = auth.profile.usertype;
            if (role === "fleetadmin") {
              data["fleetadmin"] = auth.profile.uid;
            }
          data['adminApprovedTrue'] = data.approved === true;
          data['driverApproved'] = data.approved === true;
          return dispatch(addUser(data));
        })
        .then(() => {
          dispatch(fetchUsersOnce());
          navigate("/users/1");
        })
        .catch((error) => {
          let errorMessage;
          try {
            const errorObj = JSON.parse(error.message);
            if (errorObj.errorType === 'invalid_mobile_length') {
              errorMessage = t("mobile_err_txt1") + " " + errorObj.expectedMobileLength + " " + t("mobile_err_txt2") + errorObj.actualMobileLength + t("mobile_err_txt3");
            } else {
              errorMessage = t(errorObj.errorType || "email_or_mobile_issue");
            }
          } catch (e) {
            errorMessage = t("email_or_mobile_issue");
          }
          setCommonAlert({ open: true, msg: errorMessage });
        })
        .finally(() => {
          setLoding(false);
        });
    }
  };

  return loding ? (
    <CircularLoading />
  ) : (
    <div>
      <Card
        style={{
          borderRadius: "19px",
          backgroundColor: "#fff",
          minHeight: 100,
          maxWidth: "75vw",
          marginTop: 20,
          marginBottom: 20,
          padding: 25,
          alignItems: "center",
          justifyContent: "center",
          boxShadow: `0px 2px 5px ${colors.SECONDARY}`,
        }}
      >
        <Typography
          variant="h5"
          style={{
            marginTop: -15,
            textAlign: isRTL === "rtl" ? "right" : "left",
          }}
        >
          {t("add_driver_title")}
        </Typography>
        <div
          dir={isRTL === "rtl" ? "rtl" : "ltr"}
        >
          <Button
            variant="text"
            onClick={() => {
              navigate( '/users/1',  { state: { pageNo: state?.pageNo }} )
            }}
          >
            <Typography
              style={{
                marginBottom: 10,
                textAlign: isRTL === "rtl" ? "right" : "left",
                fontWeight: "bold",
                color: colors.MAIN_COLOR
              }}
            >
              {`<<- ${t("go_back")}`}
            </Typography>
          </Button>
        </div>
        <Grid
          container
          spacing={2}
          sx={{ direction: isRTL === "rtl" ? "rtl" : "ltr", gridTemplateColumns: "50%" }}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TextField
              label={t("firstname")}
              id="firstName"
              value={data.firstName}
              fullWidth
              onChange={handleInputChange}
              className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TextField
              label={t("last_name")}
              id="lastName"
              value={data.lastName}
              fullWidth
              onChange={handleInputChange}
              className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            { countries && countries.length > 0 ?
              <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : 'ltr' }}>
              <InputLabel
                id="demo-simple-select-label"
                className={isRTL === "rtl" ? classes.right : ""}
                sx={{ "&.Mui-focused": { color: colors.MAIN_COLOR } }}
              >
                {t("select_country")}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={data.country || ""}
                label={t("select_country")}
                onChange={handleCountryChange}
                className={isRTL === "rtl" ? classes.selectField_rtl : classes.selectField}
              >
              {countries.map((item, idx)=>(
                <MenuItem style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }} value={item.label} key = {idx}>{item.label}</MenuItem>
              ))}
              </Select>
            </FormControl>
              : null}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <TextField
              label={t("mobile")}
              id="mobile"
              value={data.mobile}
              fullWidth
              onChange={handleInputChange}
              className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TextField
              label={t("email")}
              id="email"
              value={data.email}
              fullWidth
              onChange={handleInputChange}
              className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : 'ltr' }}>
              <InputLabel id="demo-simple-select-label" className={isRTL === "rtl" ? classes.right : ""} sx={{ "&.Mui-focused": { color: colors.MAIN_COLOR } }}>
                {t("approve_status")}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={approved}
                label={t("approve_status")}
                onChange={handleChangeApproved}
                className={isRTL === "rtl" ? classes.selectField_rtl : classes.selectField}
              >
                <MenuItem style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }} value={true}>{t("approved")}</MenuItem>
                <MenuItem style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }} value={false}>{t("not_approved")}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : 'ltr' }}>
              <InputLabel id="demo-simple-select-label" className={isRTL === "rtl" ? classes.right : ""} sx={{ "&.Mui-focused": { color: colors.MAIN_COLOR } }}>
                {t('driver_active')}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={active}
                label={t('driver_active')}
                onChange={handleChangeActive}
                className={isRTL === "rtl" ? classes.selectField_rtl : classes.selectField}
              >
                <MenuItem style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }} value={true}>{t("active")}</MenuItem>
                <MenuItem style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }} value={false}>{t("not_active")}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TextField
              label={t("verify_id")}
              id="verifyId"
              value={data?.verifyId}
              fullWidth
              onChange={handleInputChange}
              className={isRTL === "rtl" ? classes.rootRtl_3 : classes.textField}
            />
          </Grid>
          {role !== "fleetadmin" ? (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={6}
              xl={6}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : 'ltr' }}>
                <InputLabel id="fleetadmins" className={isRTL === "rtl" ? classes.right_1 : ""} sx={{ "&.Mui-focused": { color: colors.MAIN_COLOR } }}>{t("fleetadmins")}</InputLabel>
                <Select
                  labelId="fleetadmins"
                  id="select"
                  value={fleet || ""}
                  label={t("fleetadmins")}
                  onChange={handleChangeFleetAdmin}
                  className={isRTL === "rtl" ? classes.selectField_rtl : classes.selectField}
                >
                  {fleetAdmins
                    ? fleetAdmins.map((e) => (
                      <MenuItem style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }} key={e.id} value={fleetAdminsObj[e.id]}>
                        {e.desc}
                      </MenuItem>
                    ))
                    : null}
                </Select>
              </FormControl>
            </Grid>
          ) : null}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={6}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Button
              style={{
                borderRadius: "19px",
                backgroundColor: colors.MAIN_COLOR,
                minHeight: 50,
                textAlign: "center",
                width: "100%"
              }}
              onClick={handelSubmit}
              variant="contained"
            >
              <Typography
                style={{
                  color: "white",
                  textAlign: "center",
                  fontSize: 16,
                }}
              >
                {t("submit")}
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Card>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
  );
};

export default AddDriver;
